module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/color-radio-solid/color-radio-solid.component.scss
// module id = ./src/app/features/pretty-check/color-radio-solid/color-radio-solid.component.scss
// module chunks = main